import { StyleSheet } from 'aphrodite';
import { white } from '../../../web/styles/colors';
import { BreakPoints } from '../../../web/styles/styles';
import { MobileBreakpoint } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	body: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			flexGrow: 0,
		},
	},
	container: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
	},
	content: {
		margin: '0 auto',
		width: '100%',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		[BreakPoints.forMinWidth(768)]: {
			boxShadow: `0 0 6px 0 rgba(139,139,139,0.10)`,
			width: '100%',
			paddingTop: 0,
		},
	},
	footer: {
		alignItems: 'center',
		color: white,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 12,
		justifyContent: 'center',
		backgroundColor: white,
		flexShrink: 0,
		paddingTop: 16,
	},
	customHeader: {
		flexShrink: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: '100%',
	},
	customFooter: {
		flexShrink: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: '100%',
	},
	fullHeightWrapper: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
	},
});
